@if (patientReferralMatchVerifications.length > 0) {
  <table class="table table-sm table-bordered mb-1">
    <thead class="table-dark">
      <tr>
        <th>RECEIVING PROVIDER / PRACTICE</th>
        <th>SPECIALTY</th>
        <th>RECEIVING OFFICE</th>
        <th>REFERRING PROVIDER</th>
        <th>REF-DATE</th>
        <th>REF-ID</th>
        <th>STATUS</th>
        <th>NOTES</th>
        <th>CONSULT</th>
        <th>CONSULT DESC</th>
        <th>PT CONSULT DESC</th>
      </tr>
    </thead>
    <tbody>
      @for (rmv of patientReferralMatchVerifications; track rmv) {
        <tr>
          <td>
            <div class="d-flex">
              @if (rmv.provider) {
                <div class="selection me-1">
                  <fa-icon [icon]="['fas', 'check-circle']" size="1x" class="check" />
                </div>
              }
              <div>
                {{ rmv.referral.receivingProviderDisplayNameWithNpi }} <br />
                {{ rmv.referral.receivingProviderDisplaySpecialty }}
              </div>
            </div>
          </td>
          <td>
            <div class="d-flex">
              @if (rmv.specialty) {
                <div class="selection me-1">
                  <fa-icon [icon]="['fas', 'check-circle']" size="1x" class="check" />
                </div>
              }
              <div>{{ rmv.referral.referralSpecialty }}</div>
            </div>
          </td>
          <td>
            <div class="d-flex">
              @if (rmv.office) {
                <div class="selection me-1">
                  <fa-icon [icon]="['fas', 'check-circle']" size="1x" class="check" />
                </div>
              }
              <div>
                <div>{{ rmv.referral.receivingOfficeName }}</div>
                <div><strong>FAX:</strong> {{ rmv.referral.receivingProviderFax }}</div>
              </div>
            </div>
          </td>
          <td>{{ rmv.referral.sendingProviderDisplayNameWithNpi }}</td>
          <td>{{ rmv.referral.referralDate | date: 'MM/dd/yyyy' }}</td>
          <td>{{ rmv.referral.ehrIdentifier }}</td>
          <td>{{ rmv.referral.referralEhrStatus }}</td>
          <td>{{ rmv.referral.referralEhrNotes }}</td>
          <td>{{ rmv.referral.referralConsultInEhr }}</td>
          <td>{{ rmv.referral.referralConsultEhrDescriptions }}</td>
          <td>{{ rmv.referral.patientConsultEhrDescriptions }}</td>
        </tr>
      }
    </tbody>
  </table>
}
